<template>
  <div class="range-input">
    <div class="edit" v-if="!readOnly" >
      <text-with-units v-model="internalValue[0]" :unit="view.units" :min="minVal" :max="maxVal" />
      <text-with-units v-model="internalValue[1]" :unit="view.units" :min="minVal" :max="maxVal" />
    </div>
    <span v-else class="value">[{{internalValue[0]}}, {{internalValue[1]}}]</span>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'
import TextWithUnits from '@/components/inputs/TextWithUnits'

export default {
  name: 'RangeInput',
  mixins: [inputMixin],
  components: {TextWithUnits},
  computed:{
    minValue: {
      get(){
        return internalValue[0]
      },
      set(val){
        this.internalValue = [val,this.maxValue]
      }
    },
    maxValue: {
      get(){
        return internalValue[1]
      },
      set(val){
        this.internalValue =  [this.minValue,val]
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.range-input
  .edit
    display flex
  .input-with-units
    m-font-size(14,15)
    border none
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 4px;
    min-width 20px
    margin-right 6px
</style>